import { State, states } from './states';

export const NewfoundlandAndLabrador: State = { name: 'Newfoundland and Labrador', abbreviation: 'NL' };
export const PrinceEdwardIsland: State = { name: 'Prince Edward Island', abbreviation: 'PE' };
export const NovaScotia: State = { name: 'Nova Scotia', abbreviation: 'NS' };
export const NewBrunswick: State = { name: 'New Brunswick', abbreviation: 'NB' };
export const Quebec: State = { name: 'Quebec', abbreviation: 'QC' };
export const Ontario: State = { name: 'Ontario', abbreviation: 'ON' };
export const Manitoba: State = { name: 'Manitoba', abbreviation: 'MB' };
export const Saskatchewan: State = { name: 'Saskatchewan', abbreviation: 'SK' };
export const Alberta: State = { name: 'Alberta', abbreviation: 'AB' };
export const BritishColumbia: State = { name: 'British Columbia', abbreviation: 'BC' };
export const Yukon: State = { name: 'Yukon', abbreviation: 'YT' };
export const NorthwestTerritories: State = { name: 'Northwest Territories', abbreviation: 'NT' };
export const Nunavut: State = { name: 'Nunavut', abbreviation: 'NU' };

export const provinces: readonly State[] = [
  NewfoundlandAndLabrador,
  PrinceEdwardIsland,
  NovaScotia,
  NewBrunswick,
  Quebec,
  Ontario,
  Manitoba,
  Saskatchewan,
  Alberta,
  BritishColumbia,
  Yukon,
  NorthwestTerritories,
  Nunavut,
];

export const statesAndProvinces: readonly State[] = [...states, ...provinces];
